<template>
  <div class="checklist__control">
    <!-- template drag&drop icon -->
    <div v-if="isEditable" class="checklist__control-icon checklist__control-icon--draggable">
      <img :src="dragIcon" />
    </div>
    <!-- template drag&drop icon -->
    <div v-else-if="!isTemplatePage" class="checklist__status">
      <div class="checklist__status-control" :class="[statusClass, completedClass]">
        <div class="checklist__status-control-icon">
          <!-- lock and active -->
          <AppIcon v-if="!isCompleted" :icon="statusIcon" />
          <!-- completed -->
          <AppIcon v-else icon="fas fa-check" />
        </div>
      </div>
    </div>
    <div v-if="!isTemplatePage" class="checklist__control-arrow">
      <AppIcon icon="fas fa-caret-right" />
    </div>
  </div>
</template>

<script>
// Utilities
import DragIcon from 'Images/svg/drag-icon.svg'
import PageControl from '../mixins/pageControl'

export default {
  name: 'ChecklistsChecklistControl',

  components: {
    AppIcon: () => import('Ui/AppIcon'),
  },

  props: {
    isCompleted: {
      type: Boolean,
      required: true,
    },

    checklist: {
      type: Object,
      required: true,
    },
  },

  mixins: [PageControl],

  computed: {
    dragIcon() {
      return DragIcon
    },

    statusClass() {
      return this.checklist.is_active ? 'active' : 'locked'
    },

    statusIcon() {
      return this.statusClass === 'locked' ? 'fa fa-lock' : ''
    },

    completedClass() {
      return this.isCompleted && 'completed'
    },
  },
}
</script>

<style scoped>
.checklist__control {
  position: relative;
}

.template .checklist__control {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: all-scroll;
}

.checklist__control-arrow {
  position: absolute;
  font-size: 14px;
  right: 0;
  top: 7px;
  will-change: transform;
  transform-origin: center;
  transition: var(--transition--default);
}

.visible .checklist__control-arrow {
  transform: rotate(90deg);
}

.locked .checklist__control-arrow {
  color: var(--c-secondary-500);
}

.checklist__control-icon img {
  pointer-events: none;
}

.checklist__status-control {
  position: absolute;
  left: 0;
  top: 8px;
  width: 20px;
  height: 20px;
  border: 2px solid var(--c-secondary-500);
  border-radius: 50px;
  background-color: var(--c-secondary-200);
  transition: var(--transition--default);
  z-index: 2;
}

.checklist__status-control.completed {
  background-color: var(--c-primary);
}

.active .checklist__status-control,
.completed .checklist__status-control {
  border-color: var(--c-primary);
}

.checklist__status-control-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
}

.checklist__status-control .app-icon {
  font-size: 9px;
  line-height: 0;
  pointer-events: none;
}

.checklist__status-control.locked .app-icon {
  color: var(--c-secondary-500);
}

.checklist__status-control.completed .app-icon {
  color: #fff;
}
</style>
